import Vue from 'vue'

import 'mdn-polyfills/String.prototype.endsWith'
import 'mdn-polyfills/Object.entries'
import 'babel-polyfill'


import SfcModalComponent from "@/common/components/sfc-modal"
Vue.component('sfc-modal', SfcModalComponent)


// Ad and tracking services
import SfcSentry from '@/layouts/common/sfc-sentry'
import SfcDfp from '@/layouts/common/sfc-dfp'
import SfcHeap from '@/layouts/common/sfc-heap'
import SfcDfpAd from '@/common/components/sfc-dfp-ad'

Vue.component('sfc-sentry', SfcSentry)
Vue.component('sfc-dfp-ad', SfcDfpAd)
Vue.component('dfp-ad', SfcDfpAd)
Vue.component('sfc-heap', SfcHeap)
Vue.component('sfc-dfp', SfcDfp)

// inputs/social media
import SfcCheckbox from '@/common/components/inputs/checkbox'
import SfcSelect from '@/common/components/inputs/select'
import SfcTextBox from '@/common/components/inputs/textbox'
import SfcProgressBar from '@/common/components/inputs/progress-bar'
import SfcRadio from '@/common/components/inputs/radio'

Vue.component('sfc-checkbox', SfcCheckbox)
Vue.component('sfc-select-wrapper', SfcSelect)
Vue.component('sfc-progress-bar', SfcProgressBar)
Vue.component('sfc-input', SfcTextBox)
Vue.component('sfc-radio-input', SfcRadio)


// images and icons
import SfcCapStarScore from '@/common/components/cap-star-score'
import SfcTooltipIcon from '@/common/components/icons/tooltip-icon'
import SfcXIcon from '@/common/components/icons/x-icon'

Vue.component('sfc-tooltip-icon', SfcTooltipIcon)
Vue.component('sfc-x-icon', SfcXIcon)
Vue.component('sfc-cap-star-score', SfcCapStarScore)

// ------------------
// used often components
// ------------------
import SfcSidebarAds from '@/layouts/common/sfc-sidebar-ads'
import SfcBest529PlansWidget from '@/common/components/experiments/widgets/sfc-best-529-plans-widget'
import SfcUsMap from '@/common/components/sfc-us-map'
import SfcYoutube from '@/common/components/sfc-youtube'
import SfcGdprBanner from '@/layouts/common/sfc-gdpr-banner'
import SfcGtmBody from '@/layouts/common/sfc-gtm-body'
import EnrollNowButton from '@/common/components/sfc-enroll-now-button'
import SfcHtmlEvaluator from '@/common/components/sfc-html-evaluator'
import SfcOnboardingModalV3 from '@/common/components/savings-center/v3/onboarding/modal'
import SfcOnboardingMobileModalV3 from '@/common/components/savings-center/v3/onboarding/mobile-modal'
import SfcSearch from '@/common/components/sfc-search'

Vue.component('sfc-sidebar-ads', SfcSidebarAds)
Vue.component('sfc-best-529-plans-widget', SfcBest529PlansWidget)
Vue.component('sfc-us-map', SfcUsMap)
Vue.component('sfc-youtube', SfcYoutube)
Vue.component('sfc-gdpr-banner', SfcGdprBanner)
Vue.component('sfc-gtm-body', SfcGtmBody)
Vue.component('sfc-enroll-now-button', EnrollNowButton)
Vue.component('sfc-html-evaluator', SfcHtmlEvaluator)
Vue.component('sfc-onboarding-modal-v3', SfcOnboardingModalV3)
Vue.component('sfc-onboarding-mobile-modal-v3', SfcOnboardingMobileModalV3)
Vue.component('sfc-search', SfcSearch)